"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackEecProductClick = void 0;
const enums_1 = require("../enums");
const buildEecProduct_1 = require("./buildEecProduct");
const buildGA4ProductInteractionEvent_1 = require("./buildGA4ProductInteractionEvent");
const clearGA4EventData_1 = require("./clearGA4EventData");
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackEecProductClick({ product, position, list, featureCategory, itemListName, itemListType, isLocationSelected, }) {
    const isGA4EventEnabled = featureCategory && itemListName;
    if (isGA4EventEnabled)
        (0, clearGA4EventData_1.clearGA4EventData)();
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: enums_1.EventName.EECProductClick,
        ecommerce: {
            click: {
                actionField: {
                    list: list || 'Category',
                    action: 'click',
                },
                products: [(0, buildEecProduct_1.buildEecProduct)({ product, position })],
            },
        },
        ...(isGA4EventEnabled
            ? (0, buildGA4ProductInteractionEvent_1.buildGA4ProductInteractionEvent)({
                eventName: enums_1.GA4EventName.SelectItem,
                featureCategory,
                itemListName,
                itemListType,
                product,
                position,
                isLocationSelected,
            })
            : undefined),
    });
}
exports.trackEecProductClick = trackEecProductClick;
//# sourceMappingURL=trackEecProductClick.js.map